const partToLetterMap: Partial<Record<Intl.DateTimeFormatPartTypes, string>> = {
	month: "M",
	day: "D",
	year: "Y",
	minute: "m",
	second: "s",
	hour: "H",
};

export function printDateFormat(format: Intl.DateTimeFormat): string {
	return format
		.formatToParts(1e12)
		.map((part) => {
			const letter = partToLetterMap[part.type];
			if (letter) {
				return letter.repeat(part.value.length);
			}
			if (part.type === "literal") {
				return part.value;
			}
			return "";
		})
		.join("");
}
